import React from 'react';
import { secondsToHMS } from 'shared/components/charts';

import {
  ProgressBarFill,
  ProgressBarTrack,
  ProjectColorDot,
  ProjectEmptyBox,
  ProjectTableCell,
  ProjectTableDuration,
  ProjectTableHeader,
  ProjectTableHeaderCell,
  ProjectTableName,
  ProjectTableNameCell,
  ProjectTablePct,
  ProjectTableRow,
  ProjectTableTitle,
} from '../dashboard.styles';
import type { DashboardProjectEntry } from '../types/dashboard.types';

interface Props {
  projects: DashboardProjectEntry[];
}

const DashboardProjectList: React.FC<Props> = ({ projects }) => {
  if (projects.length === 0) {
    return <ProjectEmptyBox>No project data</ProjectEmptyBox>;
  }

  return (
    <>
      <ProjectTableTitle>Top Projects</ProjectTableTitle>

      <ProjectTableHeader>
        <ProjectTableHeaderCell>Project</ProjectTableHeaderCell>
        <ProjectTableHeaderCell>Client</ProjectTableHeaderCell>
        <ProjectTableHeaderCell>Duration</ProjectTableHeaderCell>
        <ProjectTableHeaderCell sx={{ textAlign: 'right', paddingRight: '8px' }}>%</ProjectTableHeaderCell>
        <ProjectTableHeaderCell>Progress</ProjectTableHeaderCell>
      </ProjectTableHeader>

      {projects.map((p) => (
        <ProjectTableRow key={p.projectId}>
          <ProjectTableNameCell>
            <ProjectColorDot dotcolor={p.color} />
            <ProjectTableName title={p.name}>{p.name}</ProjectTableName>
          </ProjectTableNameCell>

          <ProjectTableCell title={p.clientName ?? '—'}>
            {p.clientName ?? '—'}
          </ProjectTableCell>

          <ProjectTableDuration>{secondsToHMS(p.totalSecs)}</ProjectTableDuration>

          <ProjectTablePct>{Math.round(p.percentage)}%</ProjectTablePct>

          <ProgressBarTrack sx={{ mt: 0 }}>
            <ProgressBarFill fillcolor={p.color ?? '#4caf50'} pct={p.percentage} />
          </ProgressBarTrack>
        </ProjectTableRow>
      ))}

    </>
  );
};

export default DashboardProjectList;
